import Vue from 'vue'
import { RouteConfig } from 'vue-router'

export const AppRoutes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    redirect: '/cems/svg/default/d',
  },

  {
    path: '/cems',
    name: 'CEMS',
    redirect: '/cems/svg/default',
    component: () => import('@/apps/cems_v1/layouts/v1/index.vue'),
    children: [
      {
        path: 'svg',
        name: 'CemsSvg',
        redirect: '/cems/svg/default/d',
      },

      {
        path: 'svg/:uid',
        name: 'CemsSvg',
        redirect: '/cems/svg/default/d',
      },

      {
        path: 'svg/:uid/:slug',
        name: 'CemsV1Svg',
        component: () => import('@/apps/cems_v1/svg/index.vue'),
        meta: { title: 'CEMS', roles: ['user', 'operator', 'admin'] },
      },

      {
        path: 'last-measurement',
        name: 'LastMeasurement',
        component: () => import('@/apps/cems_v1/home/index.vue'),
        meta: { title: 'CEMS' },
      },
      {
        path: 'alarm',
        name: 'AlarmPage',
        component: () => import('@/apps/cems_v1/alarm/index.vue'),
        meta: { title: 'Alarm', roles: ['operator', 'admin'] },
      },
      {
        path: 'historical-data',
        name: 'CEMSHistoricalData',
        component: () => import('@/apps/cems_v1/historical-data/index.vue'),
        meta: { title: 'Historical data', roles: ['operator', 'admin'] },
      },
      {
        path: 'historical-trend',
        name: 'CEMSHistoricalTrend',
        component: () => import('@/apps/cems_v1/historical-trend/index.vue'),
        meta: { title: 'Historical data', roles: ['operator', 'admin'] },
      },
      {
        path: 'report',
        name: 'Report',
        component: () => import('@/apps/cems_v1/report/index.vue'),
        meta: { title: 'CEMS | Report', roles: ['operator', 'admin'] },
      },
      {
        path: 'sync-log',
        name: 'SyncLog',
        component: () => import('@/apps/cems_v1/sync-log/index.vue'),
        meta: {
          title: 'CEMS | Synchronization Logs',
          roles: ['operator', 'admin'],
        },
      },
      {
        path: 'action-log',
        name: 'ActionLog',
        component: () => import('@/apps/cems_v1/action-log/index.vue'),
        meta: { title: 'CEMS | Action Logs', roles: ['operator', 'admin'] },
      },
    ],
  },

  {
    path: '/cems',
    name: 'CEMSSecure',
    redirect: '/report',
    component: () => import('@/apps/cems_v1/layouts/v1/index.vue'),
    meta: { roles: ['admin'] },
    children: [
      {
        path: 'setting',
        name: 'CEMSSetting',
        component: () => import('@/apps/cems_v1/setting/index.vue'),
        redirect: '/cems/setting/company-profile',
        children: [
          {
            path: 'home-page',
            name: 'SettingHomePage',
            component: () =>
              import('@/apps/cems_v1/setting/home-page/index.vue'),
            meta: { title: 'Home page' },
          },

          // --------------------------------------------------------------------------------
          // Setting users
          // --------------------------------------------------------------------------------
          {
            path: 'user',
            name: 'SettingUser',
            component: () => import('@/apps/cems_v1/setting/user/index.vue'),
            meta: { title: 'User settting' },
          },
          {
            path: 'user/create',
            name: 'CreateNewUser',
            component: () => import('@/apps/cems_v1/setting/user/new-user.vue'),
            meta: { title: 'Create new user' },
          },
          {
            path: 'user/:id/edit',
            name: 'EditUser',
            component: () =>
              import('@/apps/cems_v1/setting/user/edit-user.vue'),
            meta: { title: 'Edit user' },
          },

          // --------------------------------------------------------------------------------
          // Setting company profile
          // --------------------------------------------------------------------------------
          {
            path: 'company-profile',
            name: 'CompanyProfile',
            component: () =>
              import('@/apps/cems_v1/setting/company-profile.vue'),
            meta: { title: 'Company profile' },
          },
          {
            path: 'regional',
            name: 'RegionalSetting',
            component: () => import('@/apps/cems_v1/setting/regional.vue'),
            meta: { title: 'Regional setting' },
          },

          // --------------------------------------------------------------------------------
          // Setting chimney
          // --------------------------------------------------------------------------------
          {
            path: 'chimney',
            name: 'ChimneySetting',
            component: () => import('@/apps/cems_v1/setting/chimney/index.vue'),
            meta: { title: 'Chimney' },
          },

          {
            path: 'chimney/add',
            name: 'AddNewChimney',
            component: () =>
              import('@/apps/cems_v1/setting/chimney/form-add-chimney.vue'),
          },

          {
            path: 'chimney/:stackUID',
            name: 'ChimneyEdit',
            component: () =>
              import('@/apps/cems_v1/setting/chimney/container.vue'),
            meta: { title: 'Edit Chimney' },
            redirect: '/cems/setting/chimney/:chimneyId/general',
            children: [
              {
                path: 'general',
                name: 'ChimneyGeneral',
                component: () =>
                  import('@/apps/cems_v1/setting/chimney/general.vue'),
                meta: { title: 'General' },
              },
              {
                path: 'parameter',
                name: 'ChimneyParameters',
                component: () =>
                  import('@/apps/cems_v1/setting/chimney/parameters.vue'),
                meta: { title: 'Parameters' },
              },
              {
                path: 'status',
                name: 'ChimneyStatus',
                component: () =>
                  import('@/apps/cems_v1/setting/chimney/status.vue'),
                meta: { title: 'Status' },
              },
              {
                path: 'qaqc',
                name: 'StackQAQC',
                component: () =>
                  import('@/apps/cems_v1/setting/chimney/qaqc.vue'),
                meta: { title: 'Stack QAQC' },
              },
              {
                path: 'data-logger',
                name: 'StackDataLogger',
                component: () =>
                  import('@/apps/cems_v1/setting/chimney/data-logger.vue'),
                meta: { title: 'Data logger' },
              },
              {
                path: 'sispek',
                name: 'StackSispek',
                component: () =>
                  import('@/apps/cems_v1/setting/chimney/sispek.vue'),
                meta: { title: 'SISPEK' },
              },
              {
                path: 'siplah',
                name: 'StackSiplah',
                component: () =>
                  import('@/apps/cems_v1/setting/chimney/siplah.vue'),
                meta: { title: 'SIPLAH' },
              },
            ],
          },

          {
            path: 'chimney/:stackUID/parameter',
            name: 'ChimneyParameter',
            component: () =>
              import('@/apps/cems_v1/setting/chimney/container.vue'),
            meta: { title: 'Edit parameter' },
            children: [
              {
                path: 'new-parameter',
                name: 'ChimneyAddParameter',
                component: () =>
                  import('@/apps/cems_v1/setting/chimney/add-parameter.vue'),
                meta: { title: 'Add new parameter' },
              },
              {
                path: ':parameterUID',
                name: 'ChimneyEditParameter',
                component: () =>
                  import('@/apps/cems_v1/setting/chimney/edit-parameter.vue'),
                meta: { title: 'Edit parameter' },
              },
            ],
          },

          // --------------------------------------------------------------------------------
          // Setting QAQC
          // --------------------------------------------------------------------------------
          {
            path: 'qaqc',
            name: 'SettingQAQC',
            component: () => import('@/apps/cems_v1/setting/qaqc/index.vue'),
            meta: { title: 'Setting QAQC' },
          },

          {
            path: 'qaqc/create',
            name: 'CreateQAQC',
            component: () =>
              import('@/apps/cems_v1/setting/qaqc/form-create.vue'),
            meta: { title: 'Create New QAQC' },
          },
          {
            path: 'qaqc/:qaqcId',
            name: 'EditQAQC',
            component: () =>
              import('@/apps/cems_v1/setting/qaqc/edit-qaqc.vue'),
            meta: { title: 'Edit QAQC' },
            redirect: { name: 'QAQCGeneralProp' },
            children: [
              {
                path: 'general',
                name: 'QAQCGeneralProp',
                component: () =>
                  import('@/apps/cems_v1/setting/qaqc/form-edit-general.vue'),
              },
              {
                path: 'normal-data',
                name: 'QAQCNormalDataProp',
                component: () =>
                  import('@/apps/cems_v1/setting/qaqc/form-edit-normal.vue'),
              },
            ],
          },

          // --------------------------------------------------------------------------------
          // Setting sispek
          // --------------------------------------------------------------------------------
          {
            path: 'sispek',
            name: 'SispekSetting',
            component: () => import('@/apps/cems_v1/setting/sispek/index.vue'),
            meta: { title: 'SISPEK' },
          },

          // --------------------------------------------------------------------------------
          // Setting SIPLAH
          // --------------------------------------------------------------------------------
          {
            path: 'siplah',
            name: 'SettingSIPLAH',
            component: () => import('@/apps/cems_v1/setting/siplah/index.vue'),
            meta: { title: 'SIPLAH' },
          },
          // --------------------------------------------------------------------------------
          // Setting Token
          // --------------------------------------------------------------------------------
          {
            path: 'developer',
            name: 'SettingDeveloper',
            component: () =>
              import('@/apps/cems_v1/setting/developer/index.vue'),
            meta: { title: 'Developer' },
          },

          // --------------------------------------------------------------------------------
          // Setting DEVICE
          // --------------------------------------------------------------------------------
          {
            path: 'device',
            name: 'DeviceList',
            component: () => import('@/apps/cems_v1/setting/device/index.vue'),
            meta: { title: 'Device' },
          },
          {
            path: 'device/new-device',
            name: 'Create New Device',
            component: () =>
              import('@/apps/cems_v1/setting/device/create-device.vue'),
            meta: { title: 'New Device' },
          },
          {
            path: 'device/:deviceId/configuration',
            name: 'DeviceConfiguration',
            component: () =>
              import('@/apps/cems_v1/setting/device/edit-device.vue'),
            meta: { title: 'Device Configuration' },
          },
          // --------------------------------------------------------------------------------
          // Setting notification
          // --------------------------------------------------------------------------------
          {
            path: 'notif',
            name: 'NotifSetting',
            component: () => import('@/apps/cems_v1/setting/telegram.vue'),
            meta: { title: 'Notification' },
          },

          // --------------------------------------------------------------------------------
          // Setting views
          // view pada cems menggunakan file svg
          // --------------------------------------------------------------------------------
          {
            path: 'view',
            name: 'ViewSetting',
            component: () => import('@/apps/cems_v1/setting/view/index.vue'),
            meta: { title: 'Setting View' },
          },
          {
            path: 'view/create',
            name: 'CreateNewView',
            component: () => import('@/apps/cems_v1/setting/view/new-view.vue'),
            meta: { title: 'Create new view' },
          },
          {
            path: 'view/:viewUID/edit',
            name: 'EditSVGView',
            component: () =>
              import('@/apps/cems_v1/setting/view/edit-view.vue'),
            meta: { title: 'Edit view' },
          },

          // --------------------------------------------------------------------------------
          // Setting report
          // --------------------------------------------------------------------------------
          {
            path: 'report',
            name: 'ReportSettings',
            component: () => import('@/apps/cems_v1/setting/report/index.vue'),
            meta: { title: 'Report' },
          },
          {
            path: 'report/new',
            name: 'NewReport',
            component: () => import('@/apps/cems_v1/setting/report/new.vue'),
            meta: { title: 'New Report' },
          },
          {
            path: 'report/:id/edit',
            name: 'EditReport',
            component: () => import('@/apps/cems_v1/setting/report/edit.vue'),
            meta: { title: 'New Report' },
          },
        ],
      },
    ],
  },
]
